import "core-js/modules/es6.string.link";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import _defineProperty from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import e, { useState as a, useRef as t, useEffect as n, forwardRef as l, useMemo as s } from "react";
import r from "clsx";
import { VisuallyHidden as d, Tooltip as i } from "@hagerty/react-components";
import * as c from "@radix-ui/react-dropdown-menu";
import { Down16 as o } from "@hagerty/icons";
var _ = "GlobalHeader_module_globalHeader__52d660e3",
    m = "GlobalHeader_module_globalHeader_sticky__52d660e3",
    u = "GlobalHeader_module_isTabbing__52d660e3",
    h = "GlobalHeader_module_srOnly__52d660e3";

var v = function v(_ref) {
  var _r;

  var l = _ref.children,
      _ref$tag = _ref.tag,
      s = _ref$tag === void 0 ? "header" : _ref$tag,
      d = _ref.className,
      i = _ref.style,
      _ref$sticky = _ref.sticky,
      c = _ref$sticky === void 0 ? !1 : _ref$sticky,
      _ref$testid = _ref.testid,
      o = _ref$testid === void 0 ? "global-header" : _ref$testid;

  var _a = a(!1),
      _a2 = _slicedToArray(_a, 2),
      v = _a2[0],
      b = _a2[1],
      _a3 = a(!1),
      _a4 = _slicedToArray(_a3, 2),
      E = _a4[0],
      g = _a4[1],
      p = t(),
      C = t();

  n(function () {
    var e = function e(_e2) {
      "Tab" === _e2.key && b(!0);
    },
        a = function a() {
      b(!1);
    };

    return null === document || void 0 === document || document.addEventListener("keydown", e), null === document || void 0 === document || document.addEventListener("mousedown", a), function () {
      null === document || void 0 === document || document.removeEventListener("keydown", e), null === document || void 0 === document || document.removeEventListener("mousedown", a);
    };
  }, []);
  return e.createElement(s, {
    className: r(_, (_r = {}, _defineProperty(_r, m, c), _defineProperty(_r, u, v), _r), d),
    ref: p,
    style: i,
    "data-testid": o
  }, e.createElement("button", {
    className: r("global-header__skip", h),
    type: "button",
    onClick: function onClick() {
      var e,
          a = p.current.nextSibling;

      for (; !e;) {
        if (1 === (null == a ? void 0 : a.nodeType) && "SCRIPT" !== (null == a ? void 0 : a.tagName)) e = a;else {
          if (!(null == a ? void 0 : a.nextSibling)) {
            var _ret = function () {
              g(!0);
              var e = setInterval(function () {
                (null === document || void 0 === document ? void 0 : document.activeElement) === C.current && clearInterval(e), C.current && C.current.focus();
              }, 10);
              return "break";
            }();

            if (_ret === "break") break;
          }

          a = a.nextSibling;
        }
      }

      e && (e.setAttribute("tabIndex", "-1"), e.focus());
    }
  }, "Skip to Main Content"), l, E && e.createElement("p", {
    className: h,
    tabIndex: -1,
    ref: C
  }, "Bottom of the header"));
};

var b = "Branding_module_hdsBranding__logo__b215319a",
    E = "Branding_module_partners__b215319a",
    g = "Branding_module_affiliates__b215319a",
    p = "Branding_module_clubs__b215319a",
    C = "Branding_module_hdsBranding__wordmark__b215319a",
    N = "Branding_module_hdsBranding__b215319a";

var f = function f(_ref2) {
  var _r2;

  var a = _ref2.className,
      t = _ref2.style,
      _ref2$src = _ref2.src,
      n = _ref2$src === void 0 ? "data:image/svg+xml,%3Csvg%20width%3D%22135%22%20height%3D%2219%22%20viewBox%3D%220%200%20135%2019%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_1_2%29%22%3E%3Cpath%20d%3D%22M126.559%200.261246C126.559%200.275875%20126.542%200.307225%20126.538%200.323944C126.563%200.323944%20126.605%200.330214%20126.626%200.334394C126.931%200.386642%20127.24%200.411722%20127.537%200.49532C127.905%200.603997%20128.243%200.773282%20128.469%201.11394C128.649%201.38564%20128.701%201.67405%20128.626%201.96873C128.546%202.26759%20123.395%2015.6725%20123.234%2015.9714C123.091%2016.2326%20122.918%2016.4834%20122.711%2016.6945C122.49%2016.9244%20122.214%2017.1041%20121.9%2017.2023C121.633%2017.2859%20121.369%2017.3737%20121.098%2017.4281C120.866%2017.4761%20120.621%2017.5012%20120.385%2017.5117C120.255%2017.5179%20120.109%2017.5158%20119.977%2017.5158C119.971%2017.5221%20119.927%2017.6391%20119.921%2017.66C120.026%2017.66%20127.794%2017.66%20128.218%2017.66C128.295%2017.66%20128.337%2017.6454%20128.369%2017.5597C128.498%2017.1814%20134.983%200.288415%20135.002%200.265426%22%20fill%3D%22%23818385%22%2F%3E%3Cpath%20d%3D%22M108.83%209.74124C108.646%209.70989%20108.468%209.68272%20108.299%209.64301C107.893%209.55523%20107.486%209.45909%20107.143%209.20203C106.807%208.94915%20106.581%208.54579%20106.761%208.06719C107.003%207.40677%20109.643%200.547568%20109.747%200.280055C109.67%200.273785%20109.616%200.265426%20109.557%200.265426C107.785%200.265426%20106.015%200.269606%20104.242%200.261246C104.104%200.261246%20104.042%200.309314%20103.996%200.428441C103.833%200.884049%20100.464%209.74124%20100.436%209.84782C103.245%209.77886%20106.019%209.81021%20108.811%209.80185%22%20fill%3D%22%23818385%22%2F%3E%3Cpath%20d%3D%22M126.613%200.261246L119.95%2017.6579H114.276L120.939%200.261246H126.613Z%22%20fill%3D%22%23068DCA%22%2F%3E%3Cpath%20d%3D%22M118.134%200.261246L111.471%2017.6579H105.797L112.46%200.261246H118.134Z%22%20fill%3D%22%2317171B%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M94.0636%2015.3123H94.4467C94.7687%2015.3123%2095.125%2015.2918%2095.125%2014.9063C95.125%2014.5212%2094.7687%2014.501%2094.4467%2014.5068H94.0636V15.3123ZM93.5388%2014.0613H94.641C95.3269%2014.0613%2095.6497%2014.3725%2095.6497%2014.9268C95.6497%2015.4273%2095.3539%2015.6708%2094.9638%2015.7188L95.7093%2016.9349H95.1584L94.4467%2015.7582H94.0636V16.9349H93.5388V14.0613ZM94.5002%2017.5848C95.6358%2017.5848%2096.5572%2016.6582%2096.5572%2015.5155C96.5572%2014.3725%2095.6358%2013.4459%2094.5002%2013.4459C93.3645%2013.4459%2092.444%2014.3725%2092.444%2015.5155C92.444%2016.6582%2093.3645%2017.5848%2094.5002%2017.5848ZM94.5002%2013C95.8778%2013%2097%2014.1291%2097%2015.5155C97%2016.9012%2095.8778%2018.0307%2094.5002%2018.0307C93.1222%2018.0307%2092%2016.9012%2092%2015.5155C92%2014.1291%2093.1222%2013%2094.5002%2013Z%22%20fill%3D%22%2317171B%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M94.5688%200.272014L90.3263%2011.237V17.6532H85.286V11.237L81.3436%202.0171H78.1273V17.6532H72.7788V2.0171H68.4864V0.272014H85.8327L89.3709%208.65113L92.5551%200.272014H94.5688ZM61.9321%208.49141H60.9147V2.50629H61.9321C63.8426%202.50629%2064.7964%203.50404%2064.7964%205.4993C64.7964%207.49366%2063.8426%208.49141%2061.9321%208.49141ZM68.9327%205.35576C68.9687%203.98161%2068.3854%202.39784%2067.3774%201.50125C66.5052%200.725659%2065.2922%200.272014%2063.3456%200.272014H55.8709V17.6532H60.9147V10.3727L64.7729%2017.6532H70.2478L65.8228%209.70424C68.3004%208.27563%2068.888%207.02475%2068.9327%205.35576ZM48.5809%2015.4791H55.2675V17.6796H43.5368V0.298444H54.8059V2.49991H48.5809V7.75887H53.8127V9.96012H48.5809V15.4791ZM36.0955%207.83794H42.6263V16.7837C42.6263%2016.7837%2042.3362%2016.8332%2041.8172%2017.0086C41.2795%2017.19%2041.2148%2017.2146%2040.5643%2017.385C40.5643%2017.385%2038.2188%2017.9735%2036.6555%2017.9735C34.0827%2017.9735%2032.0856%2017.2016%2030.6636%2015.6618C29.2429%2014.1197%2028.5318%2011.949%2028.5318%209.14829C28.5318%206.42323%2029.2849%204.21743%2030.7928%202.53227C32.2968%200.848241%2034.2711%200.082444%2036.7063%200.00520345C39.6257%20-0.0861636%2042.3848%201.00067%2042.475%205.25368L40.2088%205.28353L40.1439%204.47786C39.8347%202.69358%2039.0151%201.72523%2037.2862%201.7913C35.9013%201.84394%2035.1431%202.30784%2034.7079%203.20123C34.1886%204.26482%2034.0068%206.31204%2034.0068%209.27498C34.0068%2012.0431%2034.1957%2013.9233%2034.5748%2014.9169C34.9512%2015.9113%2035.6698%2016.4071%2036.7321%2016.4071C37.9802%2016.4071%2038.6043%2015.709%2038.6043%2014.3175V10.0385H36.0955V7.83794ZM18.3131%2012.1666L20.6337%204.46191L22.7789%2012.1666H18.3131ZM19.2757%200.298444L14.1995%2016.6764V0.298444H9.15722V7.74543H5.04319V0.298444H0V17.6796H5.04319V9.94804H9.15722V17.6796H16.6336L17.7952%2013.9108H23.2754L24.3529%2017.6796H29.6606L24.5937%200.298444H19.2757Z%22%20fill%3D%22%2317171B%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_1_2%22%3E%3Crect%20width%3D%22135%22%20height%3D%2219%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E" : _ref2$src,
      _ref2$alt = _ref2.alt,
      l = _ref2$alt === void 0 ? "Hagerty Logo" : _ref2$alt,
      _ref2$type = _ref2.type,
      s = _ref2$type === void 0 ? "default" : _ref2$type,
      _ref2$href = _ref2.href,
      d = _ref2$href === void 0 ? "/" : _ref2$href,
      _ref2$testid = _ref2.testid,
      i = _ref2$testid === void 0 ? "branding" : _ref2$testid,
      c = _ref2.wordmark,
      o = _ref2.wordmarkHref;
  return e.createElement("div", {
    className: r(N, a),
    style: t,
    "data-testid": i
  }, e.createElement("a", {
    href: d,
    className: r(b, (_r2 = {}, _defineProperty(_r2, g, "affiliate" === s), _defineProperty(_r2, p, "club" === s), _defineProperty(_r2, E, "partner" === s), _r2))
  }, e.createElement("img", {
    src: n,
    alt: l
  }), c && !o && e.createElement("span", {
    className: C
  }, c)), c && o && e.createElement("span", {
    className: C
  }, e.createElement("a", {
    href: o
  }, c)));
};

function y(e, a) {
  var t = {};

  for (var n in e) {
    Object.prototype.hasOwnProperty.call(e, n) && a.indexOf(n) < 0 && (t[n] = e[n]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var l = 0;

    for (n = Object.getOwnPropertySymbols(e); l < n.length; l++) {
      a.indexOf(n[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[l]) && (t[n[l]] = e[n[l]]);
    }
  }

  return t;
}

var A = {
  "hds-navbar": "Navbar_module_hdsNavbar__37d042c0",
  "hds-navbar__left": "Navbar_module_hdsNavbar__left__37d042c0",
  "hds-navbar__right": "Navbar_module_hdsNavbar__right__37d042c0",
  "hds-navbar__center": "Navbar_module_hdsNavbar__center__37d042c0",
  "hds-navbar__primary": "Navbar_module_hdsNavbar__primary__37d042c0",
  "hds-nav": "Navbar_module_hdsNav__37d042c0",
  "hds-nav__item": "Navbar_module_hdsNav__item__37d042c0",
  active: "Navbar_module_active__37d042c0",
  "hds-navbar__secondary": "Navbar_module_hdsNavbar__secondary__37d042c0",
  "hds-navbar__secondary_menu-closed": "Navbar_module_hdsNavbar__secondary_menuClosed__37d042c0",
  "hds-nav__icon-cta": "Navbar_module_hdsNav__iconCta__37d042c0",
  "hds-nav__cta-divider": "Navbar_module_hdsNav__ctaDivider__37d042c0",
  "hds-nav__cta": "Navbar_module_hdsNav__cta__37d042c0",
  "hds-nav__cta_icon": "Navbar_module_hdsNav__cta_icon__37d042c0",
  "hds-nav__cta_overflow": "Navbar_module_hdsNav__cta_overflow__37d042c0"
};
var w = "Divider_module_divider__14416f6c";

var M = function M(_ref3) {
  var a = _ref3.className,
      t = _ref3.style,
      _ref3$testid = _ref3.testid,
      n = _ref3$testid === void 0 ? "divider" : _ref3$testid;
  return e.createElement("div", {
    className: r(w, a),
    style: t,
    "data-testid": n
  });
},
    k = l(function (a, t) {
  var _r3;

  var n = a.children,
      l = a.className,
      s = a.maxwidth,
      d = a.style,
      i = a.type,
      _a$testid = a.testid,
      c = _a$testid === void 0 ? "".concat(i, "-navbar") : _a$testid,
      o = y(a, ["children", "className", "maxwidth", "style", "type", "testid"]);
  var _ = {
    maxWidth: s,
    style: d
  };
  return e.createElement(e.Fragment, null, "secondary" === i && e.createElement(M, null), e.createElement("div", Object.assign({
    ref: t,
    id: "".concat(i, "-navbar"),
    className: r(A["hds-navbar"], (_r3 = {}, _defineProperty(_r3, A["hds-navbar__primary"], "primary" === i), _defineProperty(_r3, A["hds-navbar__secondary"], "secondary" === i), _r3), "container", l),
    style: _,
    "data-testid": c
  }, o), n));
});

k.Left = function (a) {
  var t = a.children,
      n = a.className,
      l = a.style,
      _a$testid2 = a.testid,
      s = _a$testid2 === void 0 ? "navbar-left" : _a$testid2,
      d = y(a, ["children", "className", "style", "testid"]);
  return e.createElement(e.Fragment, null, e.createElement("div", Object.assign({
    className: r(A["hds-navbar__left"], n),
    style: l,
    "data-testid": s
  }, d), t));
}, k.Center = function (a) {
  var t = a.children,
      n = a.className,
      l = a.style,
      _a$testid3 = a.testid,
      s = _a$testid3 === void 0 ? "navbar-center" : _a$testid3,
      d = y(a, ["children", "className", "style", "testid"]);
  return e.createElement(e.Fragment, null, e.createElement("div", Object.assign({
    className: r(A["hds-navbar__center"], n),
    style: l,
    "data-testid": s
  }, d), t));
}, k.Right = function (a) {
  var t = a.children,
      n = a.className,
      l = a.style,
      _a$testid4 = a.testid,
      s = _a$testid4 === void 0 ? "navbar-right" : _a$testid4,
      d = y(a, ["children", "className", "style", "testid"]);
  return e.createElement("div", Object.assign({
    className: r(A["hds-navbar__right"], n),
    style: l,
    "data-testid": s
  }, d), t);
};

var H = function H(a) {
  var t = a.children,
      n = a.className,
      l = a.style,
      _a$testid5 = a.testid,
      s = _a$testid5 === void 0 ? "nav" : _a$testid5,
      d = a.center,
      i = y(a, ["children", "className", "style", "testid", "center"]);
  return e.createElement("ul", Object.assign({
    className: r(A["hds-nav"], _defineProperty({}, A["hds-navbar__primary_center"], d), n),
    style: l,
    "data-testid": s
  }, i), t);
},
    L = function L(a) {
  var t = a.children,
      n = a.className,
      _a$href = a.href,
      l = _a$href === void 0 ? "#" : _a$href,
      _a$tag = a.tag,
      s = _a$tag === void 0 ? "a" : _a$tag,
      d = a.icon,
      i = a.style,
      c = a.onClick,
      _a$testid6 = a.testid,
      o = _a$testid6 === void 0 ? "nav-cta" : _a$testid6,
      _ = y(a, ["children", "className", "href", "tag", "icon", "style", "onClick", "testid"]);

  return e.createElement(s, Object.assign({}, _, {
    href: l,
    className: r(A["hds-nav__cta"], n),
    style: i,
    onClick: c,
    "data-testid": o
  }), t, d && e.createElement("div", {
    className: A["hds-nav__cta_icon"]
  }, d));
},
    B = function B(_ref4) {
  var _ref4$isActive = _ref4.isActive,
      a = _ref4$isActive === void 0 ? !1 : _ref4$isActive,
      t = _ref4.className,
      n = _ref4.href,
      l = _ref4.children;
  return e.createElement("li", {
    className: t
  }, e.createElement("a", {
    href: n,
    className: r(A["hds-nav__item"], _defineProperty({}, A.active, a))
  }, l));
};

var O = ["mousedown", "touchstart"],
    S = function S(e, a, t) {
  var l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : O;
  n(function () {
    var n = function n(_n) {
      t && function (e, a) {
        var t = e;

        for (; t;) {
          if ((null == t ? void 0 : t.classList) && (null == t ? void 0 : t.classList.contains(a))) return !0;
          t = t.parentElement;
        }

        return !1;
      }(_n.target, t) || e.current && !e.current.contains(_n.target) && a(_n);
    };

    return l.forEach(function (e) {
      document.addEventListener(e, n, {
        passive: !0
      });
    }), function () {
      l.forEach(function (e) {
        document.removeEventListener(e, n);
      });
    };
  }, [l, a, e, t]);
},
    V = function V(_ref5) {
  var a = _ref5.className;
  return e.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: a
  }, e.createElement("title", null, "Arrow right"), e.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.93056 4.98809L8.51219 8L5.93056 11.0119L7.06944 11.9881L10.4878 8L7.06944 4.0119L5.93056 4.98809Z",
    fill: "currentColor"
  }));
},
    x = function x(_ref6) {
  var a = _ref6.className;
  return e.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: "2",
    className: a
  }, e.createElement("path", {
    d: "M0 13.5H15V12H0V13.5ZM0 3.5H15V2H0V3.5ZM15 8.5H0V7H15V8.5Z"
  }));
},
    D = function D(_ref7) {
  var a = _ref7.className;
  return e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: r("icon", "icon_large", a)
  }, e.createElement("polygon", {
    fillRule: "evenodd",
    points: "12 10.609 18.609 4 20 5.391 13.391 12 20 18.609 18.609 20 12 13.391 5.391 20 4 18.609 10.609 12 4 5.391 5.391 4",
    fill: "currentColor"
  }));
};

var F = {
  "hds-sidebar": "Sidebar_module_hdsSidebar__213e9426",
  show: "Sidebar_module_show__213e9426",
  "hds-sidebar__brand": "Sidebar_module_hdsSidebar__brand__213e9426",
  "hds-sidebar__brand__icon": "Sidebar_module_hdsSidebar__brand__icon__213e9426",
  "hds-sidebar__head": "Sidebar_module_hdsSidebar__head__213e9426",
  "hds-sidebar__button_close": "Sidebar_module_hdsSidebar__button_close__213e9426",
  icon: "Sidebar_module_icon__213e9426",
  "hds-sidebar__list_primary": "Sidebar_module_hdsSidebar__list_primary__213e9426"
};

var I = function I(t) {
  var l = t.className,
      s = t.style,
      i = t.items,
      _t$isOpen = t.isOpen,
      c = _t$isOpen === void 0 ? !1 : _t$isOpen,
      o = t.brand,
      _ = t.onClose,
      _t$testid = t.testid,
      m = _t$testid === void 0 ? "sidebar" : _t$testid,
      u = y(t, ["className", "style", "items", "isOpen", "brand", "onClose", "testid"]);

  var _a5 = a(null),
      _a6 = _slicedToArray(_a5, 2),
      h = _a6[0],
      v = _a6[1];

  return S({
    current: h
  }, _), function (e, a) {
    n(function () {
      var t = function t(_t) {
        "Escape" === _t.key && e && a();
      };

      return null === document || void 0 === document || document.addEventListener("keydown", t), function () {
        null === document || void 0 === document || document.removeEventListener("keydown", t);
      };
    }, [e, a]);
  }(c, _), e.createElement("div", Object.assign({
    className: r(F["hds-sidebar"], _defineProperty({}, F.show, c), l),
    style: s,
    "data-testid": m
  }, u), e.createElement("div", {
    className: F["hds-sidebar__head"]
  }, e.createElement("button", {
    type: "button",
    className: F["hds-sidebar__button_close"]
  }, e.createElement(d, null, "Close menu"), e.createElement(D, {
    className: F.icon
  }))), e.createElement("div", {
    ref: v,
    className: F["hds-sidebar__body"]
  }, e.createElement("div", {
    className: F["hds-sidebar__brand"]
  }, o), e.createElement("div", {
    className: F["hds-sidebar__inner"]
  }, i)));
};

var j = "Toggle_module_hdsToggle__18d46dac";

var U = function U(a) {
  var t = a.className,
      n = a.style,
      l = a.onToggle,
      _a$testid7 = a.testid,
      s = _a$testid7 === void 0 ? "toggle" : _a$testid7,
      i = y(a, ["className", "style", "onToggle", "testid"]);
  return e.createElement("button", Object.assign({}, i, {
    type: "button",
    className: r(j, t),
    style: n,
    onClick: l,
    "data-testid": s
  }), e.createElement(d, null, "Expand menu"), e.createElement(x, null));
};

var z = {
  "hds-avatar": "Avatar_module_hdsAvatar__cba6adb9",
  "hds-avatar_size_xxxs": "Avatar_module_hdsAvatar_size_xxxs__cba6adb9",
  "hds-avatar_size_xxs": "Avatar_module_hdsAvatar_size_xxs__cba6adb9",
  "hds-avatar_size_xs": "Avatar_module_hdsAvatar_size_xs__cba6adb9",
  "hds-avatar_size_s": "Avatar_module_hdsAvatar_size_s__cba6adb9",
  "hds-avatar_size_xm": "Avatar_module_hdsAvatar_size_xm__cba6adb9",
  "hds-avatar_size_m": "Avatar_module_hdsAvatar_size_m__cba6adb9",
  "hds-avatar_size_l": "Avatar_module_hdsAvatar_size_l__cba6adb9"
};

var Q = function Q(_ref8) {
  var _ref8$src = _ref8.src,
      a = _ref8$src === void 0 ? "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAP9SURBVHgB7VuJbtpAEB3fByH9/9+rWqVplQMC+F5330a2gDjEDjObIPMkFIkYm3k79wzO/b+HlmYMl2aOKwE0c1wJoJnjSgDNHFcCaOaYPQE+WYJqFVVlTUVZUllW5j3HcSiJw/4a13XJ931yPZdcx87ZiBMAwbNdQdsso7Y9LDtAwP57TdOYF94Pw9CQIQ3RJ9R1Tc/rFy2UmvQ5kFIUBVVVRVEciWqD2J3zvKCHp9Vk4fehlKI8y40WSUGEAAi/etkQB6ANkiSwEwAbXm+2xAmQUBYlSYCdgKfV+o2z4wCIhU/hBisBmVb9c2z+I3x7AvI8J0lAC7h9ASsBZcV/Qsdo6oY4wUaAhHoOgdu/sBGg1GU2l6/VIM0cbAR4nkeXCDYCXNehSwQbAShh8ZIG9zNYfYBvwQwc5tKY9W6eFQKIFawEBIF8BwdtM9b7ESNCYQIg/Pf2AbqHN+ULThWG+/TNPYkZie7hjcXUs5RokrITEEUhSQDaIuFk2QkIg2C0L1ATKjupCCNSCywWKXEjCAOSgAgBU7RgDMy0SGg2IFYN3i6XLCEL95A6fUCMAE/P924YTAEjsoucDAFpEmt/kNBnEWhTkp4PijdEbtJ0Um7QAV4fpy8NKx0hVIlT5gW5ngLZ6jFa2Q+o0c9XIKA9mc+j47vNMBWujfrbgBUCutPEX6WavnkCHrL8deZnFiiqpm97gzQbsEJAdTQwgZCdoE3zduiJHCKJ5O0fECeg1pMcrMWMgVmZ0YJHUSAyYB2COAHrl3GjcjjKRRr1JS8IwCxQusskSsB2l9Muy05eg25yqsPkUDcJazKxziUkEyERAiB0Wda02e7evQbqHusUF+p+KipgO8TzfLEym40ALDRhLWa13lClB6WuFipNhrPAY3U/haKs9NQ5M6k1iqw4inSCxBcizyIAsR1bYDjpXXa4G4BaH84v2svmIDj2An1/nF03+v7dyB2JVNYUZgmDk4zJBJwS+hjQBKh3GseTBH99jlb/ohr83xAZiX7GZ7rSoz8Bu4bQz1rFX7O6cSi1aQRa8MQZb8OVDp04+TGh8JiMha49kEeMjR7OqV+NQdDH55V+rScJPQSo/+3Nwji99yZIRuW182zU+WswKMBgfh85z0ECOAUfwo/bG4qCoF+VNTFftSLJT6cV71Wkb0wAqv7r7q+I4B2grraWoWEiax2dtrudJn6pzfFQ5INvgTL05+8/osIDDtkfpYOIx6eVccz7OCDg99092UDgf90yxWZzmJz1BED1KwubXkh+bNX6Q0BU2neyPQGNsNp3SKLp7TFu7JfnPQGqkS8/cfph+HWn36FtBzRAGgh5S4GJ0bmw9pshpMMjih/r25b/AchD5NftFS0fAAAAAElFTkSuQmCC" : _ref8$src,
      t = _ref8.alt,
      _ref8$size = _ref8.size,
      n = _ref8$size === void 0 ? "m" : _ref8$size,
      l = _ref8.className,
      _ref8$testid = _ref8.testid,
      s = _ref8$testid === void 0 ? "avatar" : _ref8$testid;
  return e.createElement("div", {
    className: r(z["hds-avatar"], z["hds-avatar_size_".concat(n)], l),
    "aria-label": t,
    style: {
      backgroundImage: "url(".concat(a, ")")
    },
    "data-testid": s
  });
},
    T = c.Root,
    Z = c.Trigger,
    R = c.Content,
    J = c.Item;

var W = "UserMenu_module_hdsUserMenu__7977301e",
    Y = "UserMenu_module_hdsUserMenu__container__7977301e",
    P = "UserMenu_module_hdsUserMenu__login__7977301e",
    G = "UserMenu_module_hdsUserMenu__title__7977301e",
    K = "UserMenu_module_hdsUserMenu__avatar__7977301e",
    X = "UserMenu_module_hdsMenuList__7977301e",
    q = "UserMenu_module_hdsMenuList__item__7977301e";

function $(_ref9) {
  var l = _ref9.user,
      r = _ref9.options,
      d = _ref9.loginLink,
      _ref9$showMultioffice = _ref9.showMultiofficeTooltip,
      c = _ref9$showMultioffice === void 0 ? !1 : _ref9$showMultioffice;

  var _a7 = a(!1),
      _a8 = _slicedToArray(_a7, 2),
      o = _a8[0],
      _ = _a8[1],
      m = t(null),
      u = s(function () {
    return o ? function () {
      _(!1), localStorage.setItem("multiofficeTooltipDisplayed", "true");
    } : void 0;
  }, [o, _]);

  n(function () {
    c && !o && "true" !== localStorage.getItem("multiofficeTooltipDisplayed") && _(!0);
  }, [o, _, c]);
  return l && r ? e.createElement("div", {
    className: Y
  }, e.createElement(T, {
    onOpenChange: u
  }, e.createElement(Z, {
    className: W,
    id: "logged-in-user-menu",
    "data-testid": "logged-in-user-menu",
    ref: m
  }, e.createElement("div", {
    className: K
  }, e.createElement(Q, {
    src: l.avatar,
    alt: "user avatar",
    size: "xxxs"
  })), e.createElement("span", {
    className: G
  }, function (_ref10) {
    var e = _ref10.name,
        a = _ref10.firstName,
        t = _ref10.lastName;
    return e || (a && t ? "".concat(a, " ").concat(t.slice(0, 1)) : a || t || "My account");
  }(l))), e.createElement(R, {
    className: X,
    align: "end",
    alignOffset: -10,
    sideOffset: -5
  }, r.map(function (a, t) {
    return e.createElement(J, {
      key: t,
      className: q,
      asChild: !0
    }, a);
  }))), c && e.createElement(i, {
    content: e.createElement("span", {
      style: {
        whiteSpace: "nowrap"
      }
    }, "Switch offices here"),
    isVisible: o,
    triggerRef: m,
    onClickOutside: function onClickOutside() {},
    onClose: u,
    placement: "left"
  })) : d ? e.createElement("div", {
    "data-testid": "login-button",
    className: P
  }, d) : null;
}

function ee(_ref11) {
  var t = _ref11.activeNavItemIndex,
      n = _ref11.branding,
      l = _ref11.loginLink,
      s = _ref11.navigationLinks,
      r = _ref11.user,
      d = _ref11.userMenuOptions,
      i = _ref11.showMultiofficeTooltip,
      c = _ref11.className,
      o = _ref11.style;

  var _a9 = a(!1),
      _a10 = _slicedToArray(_a9, 2),
      _ = _a10[0],
      m = _a10[1];

  return e.createElement(k, {
    type: "primary",
    className: c,
    style: o
  }, e.createElement(k.Left, null, s && e.createElement(e.Fragment, null, e.createElement(I, {
    brand: e.createElement(f, Object.assign({}, n)),
    items: e.createElement(H, null, s.map(function (a, n) {
      return e.createElement(B, {
        key: n,
        href: a.href,
        isActive: t === n
      }, a.title);
    })),
    isOpen: _,
    onClose: function onClose() {
      return m(!1);
    }
  }), e.createElement(U, {
    onToggle: function onToggle() {
      return m(function (e) {
        return !e;
      });
    }
  })), e.createElement(f, Object.assign({}, n))), e.createElement(k.Center, null, e.createElement(H, null, null == s ? void 0 : s.map(function (a, n) {
    return e.createElement(B, {
      key: n,
      href: a.href,
      isActive: t === n
    }, a.title);
  }))), (r && d || l) && e.createElement(k.Right, null, e.createElement($, {
    user: r,
    options: d,
    loginLink: l,
    showMultiofficeTooltip: i
  })));
}

var ae = "Menu_module_hdsMenu__613dc34e",
    te = "Menu_module_hdsMenu__items__613dc34e",
    ne = "Menu_module_hdsMenu__item__613dc34e",
    le = "Menu_module_hdsMenu__link__613dc34e",
    se = "Menu_module_isOpen__613dc34e",
    re = "Menu_module_isActive__613dc34e",
    de = "Menu_module_hasDropdown__613dc34e",
    ie = "Menu_module_hdsMenu__dropdown__613dc34e",
    ce = "Menu_module_hasFlyout__613dc34e",
    oe = "Menu_module_hdsMenu__dropdownItem__613dc34e",
    _e = "Menu_module_hdsMenu__dropdownLink__613dc34e",
    me = "Menu_module_hdsMenu__dropdownWrapper__613dc34e",
    ue = "Menu_module_hdsMenu__dropdown_close__613dc34e",
    he = "Menu_module_icon__613dc34e",
    ve = "Menu_module_hdsMenu__dropdownIcon__613dc34e";

var be = l(function (a, t) {
  var n = a.children,
      l = a.className,
      s = y(a, ["children", "className"]);
  return e.createElement("nav", Object.assign({
    ref: t,
    className: r(ae, l)
  }, s, {
    "aria-label": "Secondary navigation"
  }), e.createElement("ul", {
    className: te
  }, e.Children.map(n, function (a) {
    return e.cloneElement(a, {
      isFirstChild: !0
    });
  })));
}),
    Ee = l(function (a, t) {
  var n = a.children,
      l = a.className,
      s = a.active,
      d = y(a, ["children", "className", "active"]);
  return e.createElement("li", Object.assign({}, d, {
    ref: t,
    className: r(oe, l, {
      active: s
    })
  }), n);
}),
    ge = function ge(_ref12) {
  var a = _ref12.children,
      t = _ref12.className,
      _ref12$isActive = _ref12.isActive,
      n = _ref12$isActive === void 0 ? !1 : _ref12$isActive;
  return e.cloneElement(a, {
    className: r(t, le, _defineProperty({}, re, n))
  });
},
    pe = l(function (_ref13, b) {
  var _r9, _r10;

  var l = _ref13.children,
      s = _ref13.className,
      d = _ref13.link,
      i = _ref13.isActive,
      c = _ref13.isOpen,
      _ = _ref13.isFirstChild,
      _ref13$showDropdownIn = _ref13.showDropdownIndicator,
      m = _ref13$showDropdownIn === void 0 ? !0 : _ref13$showDropdownIn,
      u = _ref13.index,
      h = _ref13.handleOpen,
      v = _ref13.handleClose;

  var E = Boolean(_ && !l),
      g = Boolean(_ && l),
      p = Boolean(!_),
      C = t(null),
      _a11 = a(null),
      _a12 = _slicedToArray(_a11, 2),
      N = _a12[0],
      f = _a12[1],
      _a13 = a(!1),
      _a14 = _slicedToArray(_a13, 2),
      y = _a14[0],
      A = _a14[1],
      w = function w() {
    A(!0), setTimeout(function () {
      A(!1);
    }, 300);
  },
      M = function M(e) {
    var a, t, n;
    var l = e.target,
        s = l.nextElementSibling;

    if (s) {
      var _e3 = s.querySelector("ul");

      if (_e3) {
        var _s = (null === (t = null === (a = null == l ? void 0 : l.parentElement) || void 0 === a ? void 0 : a.parentElement) || void 0 === t ? void 0 : t.offsetHeight) || 0,
            _r8 = _e3.offsetHeight;

        _r8 > _s && (null === (n = null == l ? void 0 : l.parentElement) || void 0 === n ? void 0 : n.parentElement) && (l.parentElement.parentElement.style.height = _r8 + "px");
      }
    }
  },
      k = function k(e) {
    var a, t;
    var n = e.target;
    null === (t = null === (a = null == n ? void 0 : n.parentElement) || void 0 === a ? void 0 : a.parentElement) || void 0 === t || t.removeAttribute("style");
  };

  return S({
    current: N
  }, v, "wrapper"), n(function () {
    var e = function e(_e4) {
      "Escape" === _e4.key && v();
    };

    return null === document || void 0 === document || document.addEventListener("keydown", e), function () {
      null === document || void 0 === document || document.removeEventListener("keydown", e);
    };
  }, [v]), e.createElement("li", {
    ref: b,
    className: r((_r9 = {}, _defineProperty(_r9, ne, g || E), _defineProperty(_r9, de, g), _defineProperty(_r9, oe, p), _defineProperty(_r9, ce, p), _defineProperty(_r9, se, c), _r9), s),
    onMouseOver: p ? function (e) {
      y || (c || (w(), h(u)), _ || M(e));
    } : void 0,
    onMouseLeave: p ? function (e) {
      v(), _ || k(e);
    } : void 0,
    "data-testid": "sub-menu-".concat(u)
  }, l ? e.createElement("button", {
    type: "button",
    ref: C,
    onClick: function onClick(e) {
      y || (w(), c ? v() : (h(u), _ || M(e)), _ || k(e));
    },
    className: r("wrapper", (_r10 = {}, _defineProperty(_r10, le, g), _defineProperty(_r10, _e, !g), _defineProperty(_r10, re, i), _defineProperty(_r10, se, c), _r10)),
    "aria-haspopup": !0,
    "aria-expanded": c,
    "data-testid": "sub-menu-trigger-".concat(u)
  }, g ? e.createElement(e.Fragment, null, d, m && e.createElement(o, {
    className: r(_defineProperty({}, se, c))
  })) : e.createElement(e.Fragment, null, e.createElement("span", null, d), e.createElement("span", {
    className: ve
  }))) : e.createElement(ge, {
    isActive: i
  }, d), l && e.createElement("div", {
    className: r("wrapper", me),
    ref: f
  }, g && e.createElement("button", {
    type: "button",
    className: ue,
    onClick: v
  }, e.createElement(D, {
    className: he
  })), e.createElement("ul", {
    className: ie
  }, l)));
}),
    Ce = function Ce(a) {
  var t = a.children,
      n = a.className,
      l = a.style,
      _a$href2 = a.href,
      s = _a$href2 === void 0 ? "#" : _a$href2,
      _a$tag2 = a.tag,
      d = _a$tag2 === void 0 ? "a" : _a$tag2,
      i = a.icon,
      c = a.onClick,
      _a$testid8 = a.testid,
      o = _a$testid8 === void 0 ? "nav-icon-cta" : _a$testid8,
      _ = y(a, ["children", "className", "style", "href", "tag", "icon", "onClick", "testid"]);

  return e.createElement(e.Fragment, null, e.createElement("div", {
    className: A["hds-nav__cta-divider"]
  }), e.createElement(d, Object.assign({}, _, {
    href: s,
    onClick: c,
    className: r(A["hds-nav__icon-cta"], n),
    style: l,
    "data-testid": o
  }), i, t), e.createElement("div", {
    className: A["hds-nav__cta-divider"]
  }));
};

function Ne(_ref14) {
  var t = _ref14.activeNavItemIndex,
      n = _ref14.menu,
      l = _ref14.ctaLabel,
      s = _ref14.ctaHref,
      d = _ref14.ctaOnClick,
      _ref14$navCta = _ref14.navCta,
      i = _ref14$navCta === void 0 ? {
    children: l,
    href: s,
    onClick: d
  } : _ref14$navCta,
      c = _ref14.navIconCta,
      _ref14$showDropdownIn = _ref14.showDropdownIndicator,
      o = _ref14$showDropdownIn === void 0 ? !0 : _ref14$showDropdownIn,
      _ = _ref14.className,
      m = _ref14.style;

  var _a15 = a(null),
      _a16 = _slicedToArray(_a15, 2),
      u = _a16[0],
      h = _a16[1],
      _a17 = a(null),
      _a18 = _slicedToArray(_a17, 2),
      v = _a18[0],
      b = _a18[1],
      E = function E(e) {
    h(e), b(null);
  },
      g = function g() {
    h(null), b(null);
  },
      p = function p(e) {
    b(e);
  },
      C = function C() {
    b(null);
  };

  return e.createElement(k, {
    type: "secondary",
    className: r({
      "navbar__secondary_menu-closed": null === u
    }, _),
    style: m
  }, e.createElement(k.Left, null, n && e.createElement(be, null, n.map(function (a, n) {
    return e.createElement(pe, {
      key: n,
      link: a.link,
      index: n,
      isOpen: u === n,
      isActive: t === n,
      handleOpen: E,
      handleClose: g,
      showDropdownIndicator: o
    }, a.children && a.children.length > 0 && a.children.map(function (a, t) {
      return a.children && a.children.length > 0 ? e.createElement(pe, {
        key: t,
        link: a.link,
        index: t,
        isOpen: (u === n && v) === t,
        handleOpen: p,
        handleClose: C,
        showDropdownIndicator: o
      }, a.children.map(function (a, t) {
        return e.createElement(Ee, {
          key: t
        }, a.link);
      })) : e.createElement(Ee, {
        key: t
      }, a.link);
    }));
  }))), l && e.createElement(k.Right, null, c && e.createElement(Ce, Object.assign({}, c)), e.createElement(L, Object.assign({}, i, {
    icon: e.createElement(V, null)
  }), i.children)));
}

export { f as Branding, v as GlobalHeader, ee as PrimaryHeader, Ne as SecondaryHeader };